import { COOKIE_OPTIONS } from '@/utils/constants/cookies'

export default defineNuxtPlugin(() => {
  const abVariant = useCookie<'A' | 'B'>('ab_variant', {
    ...COOKIE_OPTIONS,
    maxAge: 60 * 60 * 24 * 30 // 30 days
  })

  if (!abVariant.value) {
    abVariant.value = Math.random() < 0.5 ? 'A' : 'B'
  }
})
